import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Base } from './Base.js';
import { Number as NumberT } from './Number.js';
import * as utils from './utils.js';
var StringT = /*#__PURE__*/function (_Base) {
  _inherits(StringT, _Base);
  function StringT(length) {
    var _this;
    var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ascii';
    _classCallCheck(this, StringT);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(StringT).call(this));
    _this.length = length;
    _this.encoding = encoding;
    return _this;
  }
  _createClass(StringT, [{
    key: "decode",
    value: function decode(stream, parent) {
      var length, pos;
      var encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent, parent) || 'ascii';
      }
      var width = encodingWidth(encoding);
      if (this.length != null) {
        length = utils.resolveLength(this.length, stream, parent);
      } else {
        var buffer;
        buffer = stream.buffer;
        length = stream.length;
        pos = stream.pos;
        while (pos < length - width + 1 && (buffer[pos] !== 0x00 || width === 2 && buffer[pos + 1] !== 0x00)) {
          pos += width;
        }
        length = pos - stream.pos;
      }
      var string = stream.readString(length, encoding);
      if (this.length == null && stream.pos < stream.length) {
        stream.pos += width;
      }
      return string;
    }
  }, {
    key: "size",
    value: function size(val, parent) {
      // Use the defined value if no value was given
      if (val === undefined || val === null) {
        return utils.resolveLength(this.length, null, parent);
      }
      var encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
      }
      if (encoding === 'utf16be') {
        encoding = 'utf16le';
      }
      var size = byteLength(val, encoding);
      if (this.length instanceof NumberT) {
        size += this.length.size();
      }
      if (this.length == null) {
        size += encodingWidth(encoding);
      }
      return size;
    }
  }, {
    key: "encode",
    value: function encode(stream, val, parent) {
      var encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
      }
      if (this.length instanceof NumberT) {
        this.length.encode(stream, byteLength(val, encoding));
      }
      stream.writeString(val, encoding);
      if (this.length == null) {
        return encodingWidth(encoding) == 2 ? stream.writeUInt16LE(0x0000) : stream.writeUInt8(0x00);
      }
    }
  }]);
  return StringT;
}(Base);
function encodingWidth(encoding) {
  switch (encoding) {
    case 'ascii':
    case 'utf8':
      // utf8 is a byte-based encoding for zero-term string
      return 1;
    case 'utf16le':
    case 'utf16-le':
    case 'utf-16be':
    case 'utf-16le':
    case 'utf16be':
    case 'utf16-be':
    case 'ucs2':
      return 2;
    default:
      //TODO: assume all other encodings are 1-byters
      //throw new Error('Unknown encoding ' + encoding);
      return 1;
  }
}
function byteLength(string, encoding) {
  switch (encoding) {
    case 'ascii':
      return string.length;
    case 'utf8':
      var len = 0;
      for (var i = 0; i < string.length; i++) {
        var c = string.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff && i < string.length - 1) {
          var c2 = string.charCodeAt(++i);
          if ((c2 & 0xfc00) === 0xdc00) {
            c = ((c & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
          } else {
            // unmatched surrogate.
            i--;
          }
        }
        if ((c & 0xffffff80) === 0) {
          len++;
        } else if ((c & 0xfffff800) === 0) {
          len += 2;
        } else if ((c & 0xffff0000) === 0) {
          len += 3;
        } else if ((c & 0xffe00000) === 0) {
          len += 4;
        }
      }
      return len;
    case 'utf16le':
    case 'utf16-le':
    case 'utf16be':
    case 'utf16-be':
    case 'ucs2':
      return string.length * 2;
    default:
      throw new Error('Unknown encoding ' + encoding);
  }
}
export { StringT as String };